import React from 'react';
import cx from 'classnames';
import {CheckBox} from '@priority-software/priority-style-react';
import {getSrcFromU8Array} from '@priority-software/priority-utils/lib/file-processing';
import {Templates} from '../../constants';
import {ImageWithPopover} from './ImageWithPopover';
import {Status} from '../../../../components/Common/Status';
import {number} from '@priority-software/priority-utils/lib/number';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getFormattedDateTime} from './utils';
import styles from './styles.module.scss';

const ColumnCodes = priority.netitems.form.ColumnType;

type Props = {
    Value?: any;
    Type?: string;
    template?: Templates;
    IsStatus?: boolean | null;
    entityId?: string | null;
    ColumnType?: priority.netitems.form.ColumnType;
};

export const valuePlaceholder = '-';

export const Value = ({Value, Type, template, IsStatus, entityId, ColumnType}: Props) => {
    if (ColumnType === ColumnCodes.Attachment && !Value) return null; // leave empty for empty attachment field.

    if (ColumnType !== ColumnCodes.Boolean && !Value) return valuePlaceholder;

    if (IsStatus) {
        return (
            <span>
                {template === Templates.column && <Status status={Value} entityId={entityId} />}
                {Value}
            </span>
        );
    } else if (Type === 'Int' || Type === 'Str') {
        return Value;
    } else if (Type === 'Boolean') {
        return (
            <CheckBox
                componentClasses={cx(styles.noEvents, {
                    [styles.checkboxAlignment]: template === 'list'
                })}
                checked={Value}
            />
        );
    } else if (Type === 'Shifted') {
        return Value;
    } else if (Type === 'Real') {
        return <div className={styles.numberField}>{number(Value)}</div>;
    } else if (Type === 'Time') {
        return getFormattedDateTime(Value, 'time', ColumnCodes[ColumnType]);
    } else if (Type === 'Date') {
        return getFormattedDateTime(Value, 'date', ColumnCodes[ColumnType]);
    } else if (Type === 'File') {
        if (Value.MimeType.includes('image')) {
            if (!Value?.Data) return null;

            const src = getSrcFromU8Array(Value?.Data, Value.MimeType);

            if (template === Templates.list) {
                return <ImageWithPopover image={src} />;
            }

            return (
                <div className={styles.imgThumb}>
                    <img src={src} alt="" />
                </div>
            );
        }
    }
    return '';
};
